export default class ColorRadiiService {
    _goodNote    = 'blue';
    _badNote     = 'red';

    _badRadius  = 1
    _goodRadius = 15;

    goodColor() {
        return this._goodNote;
    }
    badColor() {
        return this._badNote;
    }
    black() {
        return "#000000";
    }
    getBadRadius() {
        return this._badRadius;
    }

    getGoodRadius() {
        return this._goodRadius;
    }
}
